import { SvgIcon, type SvgIconProps } from './svgIcon'

export const InfoIcon = ({
  width = 17,
  height = 17,
  ...props
}: SvgIconProps) => (
  <SvgIcon
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    {...props}>
    <circle cx="8" cy="8" r="7.125" stroke="currentColor" strokeWidth="1.5" />
    <path
      d="M7.78125 3.625C7.60819 3.625 7.43902 3.67632 7.29513 3.77246C7.15123 3.86861 7.03908 4.00527 6.97286 4.16515C6.90663 4.32504 6.8893 4.50097 6.92306 4.6707C6.95683 4.84044 7.04016 4.99635 7.16253 5.11872C7.2849 5.24109 7.44081 5.32442 7.61055 5.35819C7.78028 5.39195 7.95621 5.37462 8.1161 5.30839C8.27598 5.24217 8.41264 5.13002 8.50879 4.98612C8.60493 4.84223 8.65625 4.67306 8.65625 4.5C8.65625 4.26794 8.56406 4.04538 8.39997 3.88128C8.23587 3.71719 8.01331 3.625 7.78125 3.625Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.875 6.29375V10.6687H10.625V11.9812H5.8125V10.6687H7.5625V7.60625H5.8125V6.29375H8.875Z"
      fill="currentColor"
    />
  </SvgIcon>
)
